import React, { useEffect, useState } from "react";
import CustomDialog from "../../components/common/CustomDialog";
import Text from "../../components/typography/Text";
import CustomIconButton from "../../components/common/CustomButton copy/CustomIconButton";
import { MdClose, MdDelete, MdUploadFile, MdVerified } from "react-icons/md";
import { CiCirclePlus } from "react-icons/ci";
import CustomButton from "../../components/common/CustomButton/CustomButton";
import { errorToast, successToast } from "../../utils/toasts";
import Loadingbar from "../../components/common/CustomProgressbar/Loadingbar";
import * as XLSX from "xlsx";
import Grid from "../../components/layout/grid/Grid";
import CustomSelectBasic from "../../components/common/CustomSelect/CustomSelectBasic";
import { DownloadCloudIcon } from "lucide-react";
import axios from "axios";
import { getAllCategoriesUrl, getCategoryListForRelationshipManagerUrl } from "../../utils/urls";
import ErrorModal from "./ErrorModal";
import { useSelector } from "react-redux";
import CustomDropdownMenu from "../../components/CustomDropdownMenu";
import DownloadIssuanceExcel from "./DownloadIssuanceExcel";

export default function DownloadIssuanceExcelModal({ open, setOpen, companies }) {
  const loggedInUser = useSelector((state) => state.auth.user);

  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedReportType, setSelectedReportType] = useState(null);

  useEffect(() => {
    if (loggedInUser) {
      getAllCategories();
    }
    return () => {
      setCategories([]);
    }
  }, [loggedInUser])


  async function getAllCategories() {
    try {
      let url = "";
      if (loggedInUser?.rm_id) {
        url = getCategoryListForRelationshipManagerUrl;
      } else if (loggedInUser?.user_id) {
        url = `${getAllCategoriesUrl}?is_all=true`;
      }
      const response = await axios.get(url);
      if (response.data.success) {
        let activeCat = [];

        let _list = [];
        if (loggedInUser?.rm_id) {
          _list = response?.data?.data?.map((element) => element?.category_id);
        } else if (loggedInUser?.user_id) {
          _list = response?.data?.data;
        }

        _list?.forEach((element) => {
          if (element?.is_active && !element?.is_delete) {
            activeCat.push(element);
          }
        });
        setCategories(activeCat);
      }
    } catch (err) {
      console.log("lead err: ", err);
      errorToast("Error fetching categories!");
    }
  }

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <CustomDialog
      className="!h-[min(25rem,_90%)] rounded-[12px] !p-0"
      open={open}
      setOpen={setOpen}
      noTitleWrapper
      dontClose
      // height={'70%'}
      width={'min(40rem, 90%)'}
    >
      <div className="flex flex-col">
        <div className="flex flex-row gap-2 justify-between p-6 border-b">
          <div className="flex flex-col gap-2">
            <p className="text-[1.125rem] font-[600] text-[#282828]">Download Excel</p>
            <p className="text-[0.875rem] font-[400] text-[#425F80]">Download Lead Status Via Excel</p>
          </div>
          <CustomIconButton className="mt-0" icon={<MdClose />} onClick={handleClose} />
        </div>
        <div className="flex flex-row flex-wrap gap-[1rem] justify-between p-6">
          <div className="flex flex-col flex-[0_0_calc(50%_-_0.5rem)]">
            <CustomSelectBasic
              label="Category"
              placeholder="Select Category"
              multiple={false}
              value={selectedCategory}
              menuList={categories.map((element) => ({ label: element?.title, value: element?.category_id }))}
              onChange={(e) => setSelectedCategory(e.target.value)}
            />
          </div>
          <div className="flex flex-col flex-[0_0_calc(50%_-_0.5rem)]">
            <CustomSelectBasic
              label="Report Type"
              placeholder="Select Report Type"
              multiple={false}
              value={selectedReportType}
              menuList={reportTypesList.map((element) => ({ label: element, value: element }))}
              onChange={(e) => setSelectedReportType(e.target.value)}
            />
          </div>

          <div className="flex flex-col flex-[0_0_calc(100%)]">
            <DownloadIssuanceExcel selectedCategory={selectedCategory} selectedReportType={selectedReportType} closeProcess={() => {
              setOpen(false);
            }}/>

          </div>
        </div>
      </div>

    </CustomDialog>

  );
}
const reportTypesList = ['Before Issuance of Policy', 'After Issuance of Policy']